import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { stringsToOptions, stringToOption } from './FormMultiSelect';
import { Option } from '../models/table-models';

export const CustomReactSelect = ({
    updateValue,
    defaultValue,
    itemsToShow,
    translated,
}: {
    translated?: boolean;
    updateValue: (value: string | undefined | null) => void;
    defaultValue?: string;
    itemsToShow: string[];
}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    const handleSelect = (option: Option | null) => {
        updateValue(option?.value);
    };

    const getOptionLabel = (option: Option | null | undefined) => {
        const label = option ? option?.name.toLowerCase() : '';
        return translated && label.length > 0 ? t(label) : label;
    };

    return (
        <Select
            className='w-100'
            defaultValue={stringToOption(defaultValue)}
            options={stringsToOptions(itemsToShow)}
            getOptionLabel={getOptionLabel}
            getOptionValue={(option) => option?.value}
            onChange={handleSelect}
        />
    );
};
